// TelcoTrack — Google Drive strom pro HR (kontakty + složky smluv uživatelů).
// Kořen: https://drive.google.com/drive/folders/0AMoKqrGacUrJUk9PVA
//
// Očekávaná struktura pod kořenem (ensure-structure):
//   01_Kontakty/              — export kontaktů (.xlsx, sync z TelcoTrack)
//   02_Smlouvy_uzivatelu/     — jedna složka; uvnitř `{Příjmení} {Jméno} — {email}/` na uživatele

export const HR_PEOPLE_DRIVE = {
  /** Sdílený disk / kořenová složka HR (Software). */
  rootFolderId: '0AMoKqrGacUrJUk9PVA',
  /** Shared Drive id pro Drive API list/create (u tohoto disku = rootFolderId). */
  sharedDriveId: '0AMoKqrGacUrJUk9PVA',
  /** Veřejný seznam kontaktů (Excel export na Drive). */
  contactsSegment: '01_Kontakty',
  /** Soubor v `01_Kontakty` — přepisuje se při každém sync (stejný název). */
  contactsExportFileName: 'Kontakty_TelcoTrack.xlsx',
  /** Název listu uvnitř .xlsx. */
  contactsExportWorksheetTitle: 'Kontakty',
  /** `drive_managed_node.artifact_type` pro update-in-place. */
  contactsExportArtifactType: 'hr_people_contacts_xlsx',
  /** Kořen per-user složek pro generované smlouvy. */
  userContractsSegment: '02_Smlouvy_uzivatelu',
} as const;

export type HrPeopleDriveSegmentKey = keyof typeof HR_PEOPLE_DRIVE;
